import { Box, useMediaQuery } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import TextPageComponent from "../features/TextPageComponent";
import TrainWithContainer from "../features/TrainWithContainer";

export const Route = createFileRoute("/_layout/")({
  component: HomePage,
});

function HomePage() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
      }}
    >
      {isMobile && (
        <img
          src="/assets/onboarding-images/page-1.jpg"
          style={{
            width: "100%",
            maxWidth: 500,
            height: 300,
            objectFit: "cover",
          }}
        />
      )}
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <TextPageComponent
          titleText="Get a free personalized workout plan!"
          bodyText="We'll match you to the perfect plan and help you be consistent with a team of your friends."
          customComponent={
            <TrainWithContainer
              text="loved by 45,000+ members"
              images={[
                "../assets/stock-image-1.png",
                "../assets/stock-image-2.png",
                "../assets/stock-image-3.png",
              ]}
            />
          }
        />
      </Box>
    </Box>
  );
}
